import React from 'react';

/**
 * Renders inline markers from translation strings:
 *   **text** -> bold, dark
 *   __text__ -> brand blue, semibold
 */
export function renderRich(text: string): React.ReactNode[] {
  const parts = text.split(/(\*\*[^*]+\*\*|__[^_]+__)/g);
  return parts.filter(Boolean).map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={index} className="font-bold text-slate-900" data-id="element-143" data-mp="2g0yvfxf7ta53">
          {part.slice(2, -2)}
        </strong>;
    }
    if (part.startsWith('__') && part.endsWith('__')) {
      return <span key={index} className="font-semibold text-blue-600" data-id="element-144" data-mp="270ah11lwt7ro">
          {part.slice(2, -2)}
        </span>;
    }
    return <React.Fragment key={index} data-id="element-145" data-mp="221z76qvm6x9g" data-mpi={index}>{part}</React.Fragment>;
  });
}